import {Module, ModuleBuilder} from 'esp-js-ui';

import {LegalDocumentsService} from './dal';
import {ShellContainerConsts} from './ioc';
import {registerLegalStore} from './logic';

export const createLegalModule = (): Module =>
    ModuleBuilder.create('legal')
        .withInitialisation(async app => {
            const legalDocumentsService = app.container.resolve<LegalDocumentsService>(ShellContainerConsts.legal_documents_service);
            registerLegalStore(app.eventBus, legalDocumentsService);
        })
        .build();
